import React from "react";

export default function Footer() {
  return (
    <div style={{
      marginTop: "40px",
      padding: "20px",
      textAlign: "center",
      color: "#666",
      fontSize: "14px"
    }}>
        <p>© 2025 БЛИЗКО — сервис для специалистов</p>
        <p style={{ marginBottom: '36px' }}>ИП Левандовская Елена Александровна ИНН 910224909509</p>
        <p><a href='/docs/privacy-policy.pdf' target='_blank' style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold' }}>Политика конфиденциальности</a> | <a href='/docs/oferta.pdf' target='_blank' style={{ textDecoration: 'none', color: '#333', fontWeight: 'bold' }}>Оферта</a></p>
        <p style={{
            fontSize: '10px',
        }}>Под записью подразумевается бронирование помещения, <br />ИП Левандовская не несет ответственности за качество услуг, оказываемых независимыми специалистами</p>
    </div>
  );
}
